import React from 'react'
import fiveHundred from 'src/assets/images/500.svg'
import { Grid } from '@softwaredev_cegeka/stix-core'

export default function InternalServerError() {
    return (
        <Grid.Container className={'page-body error-page'}>
            <h1 className={'error-title'}>Internal server error</h1>
            <h2 className={'error-status'}>500</h2>
            <div
                style={{
                    maxWidth: '50%',
                    margin: 'auto',
                }}
            >
                <img
                    src={fiveHundred}
                    alt={'An error has occurred while processing your request.'}
                />
            </div>
        </Grid.Container>
    )
}
